/** Separated to a different function for Testing purposes */

/* eslint-disable no-param-reassign */
export const clearStylePos = (el: HTMLElement): void => {
  el.style.left = null;
  el.style.right = null;
  el.style.top = null;
  el.style.bottom = null;
};
